import { render } from "./ThemeSelector.vue?vue&type=template&id=59012050&ts=true"
import script from "./ThemeSelector.vue?vue&type=script&lang=ts"
export * from "./ThemeSelector.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__